<div class="modal-header">
  <div class="cont__modal-title">
    <!--<div class="{{pieza.Description}}"></div>-->
    <h3 class="modal-title">{{pieza.Description}}</h3>
  </div>

  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div [innerHtml]="htmlInfo"></div>

  <div class="row" *ngIf="showOptions">
    <table>
      <tr *ngFor="let option of pieza.CupraPiezaDesgasteOptions">
        <td>
          <input type="radio" [id]="option.OptionCode" name="selectedOption" [value]="option.OptionCode" [ngModel]="selectedOption" (change)="changeSelectedOption(option)">
        </td>
        <td>
          {{option.Description}}
        </td>
        <td>
          <!--{{option.Price | currency: 'EUR'}}-->
        </td>
      </tr>
    </table>
  </div>

</div>
<div class="modal-footer">
  <div class="cost__operation">{{pieza.SelectedOptionPrice | currency: 'EUR'}}</div>
  <div class="bots__actions">
    <button *ngIf="!pieza.Included" type="button" class="btn btn-add" (click)="includePieza()"><img src="../../../../assets/images/icons/add-icon.svg" alt="Añadir servicio"></button>
    <button *ngIf="pieza.Included" type="button" class="btn btn-add" (click)="includePieza()"><img src="../../../../assets/images/icons/quit-icon.svg" alt="Eliminar servicio"></button>
  </div>

</div>
